// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ROdy","tabsBox":"styles_tabsBox__2FgGn","createButton":"styles_createButton__1N62A"};